import React, { useCallback, useEffect, useState } from 'react';
import styles from './BannerFullWidthPointsSimpleVariants.module.scss';
import 'swiper/css';
import PriceProductComponent from '../../Components/PriceProductComponent/PriceProductComponent';
import CategoryProducts from '../../Components/CategoryProducts/CategoryProducts';
import SimpleVariations from '../../Components/SimpleVariations/SimpleVariations';
import GrandPage from '../../Components/GrandPage/GrandPage';
import ImagePoints from '../../Components/ImageComponent/ImagePoints';
import TitleComponent from 'components/TitleSections/Components/TitleComponent/TItleComponent';
import { getCurrentVariant, getVariantsCount, imageWrapperWithButtonRefFunction } from '../../../../functions';

const BannerFullWidthPointsSimpleVariants = ({ api }) => {
  const [properties, setProperties] = useState([]);

  const imageWrapperWithButtonRef = useCallback((node) => {
    imageWrapperWithButtonRefFunction(node);
  }, []);

  useEffect(() => {
    !!api?.attributes?.variants ? setProperties(getCurrentVariant(api.attributes.variants)) : setProperties(api.attributes);
  }, []);

  return (
    <section id={api?.id} className={`wrapper ${styles.sectionTitleSectionWithWithCategory}`}>
      <div
        className={`${styles.topContainer} ${styles.leftSide} ${
          api.attributes?.variants?.low?.image?.imagePointsCoordinates || api.attributes?.variants?.low?.image?.imagePointsYellow
            ? styles.scrollBtn
            : ''
        }`}
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-once="false"
      >
        <TitleComponent type="titleOnTop" properties={properties} />
        <div
          ref={imageWrapperWithButtonRef}
          className={`${styles.imageContainer} ${styles.imageWrapperWithButton}`}
          data-aos="zoom-in"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          <div className={`fullFrame ${styles.imagePointsWrapper}`}>
            <ImagePoints properties={properties} />
          </div>
          {!!api?.attributes?.variants && getVariantsCount(api.attributes.variants) > 1 && (
            <SimpleVariations
              type={`${!properties?.productsSumPrice ? 'positionDown' : 'centerPosition'}`}
              api={api}
              currentVariant={properties}
              setCurrentVariant={setProperties}
            />
          )}
          {api?.attributes?.priceoff != true && <PriceProductComponent type="centerPosAllBlack" properties={properties} />}
        </div>
      </div>
        {properties?.grandPage && (
      <div className={styles.downContainer}>
        <GrandPage
          properties={properties}
          blockID={api.id}
          animationData={{ animation: 'fade-up', animationDuration: '500', animationEasing: 'easy-in-out' }}
        />
        <CategoryProducts properties={properties} api={api} />
      </div>
      )}
    </section>
  );
};

export default BannerFullWidthPointsSimpleVariants;
